import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import GlyphSvg from '../components/Glyphs';
import '../utils/FAQ.css';

export default function FAQSection() {
    const [openItemId, setOpenItemId] = useState(null);
    const [glyphs, setGlyphs] = useState({}); // { faq1: 'g01', ... }

    const faqItems = [
        { id: 'faq1', question: 'How does your pricing work?', answer: <>Our pricing depends on the complexity of the job. The number of items, number of avatars, etc Typically our costing saves clients 50% or more what they otherwise pay for models. Interested in a quote and a free demo? Check out our <Link to="/pricing">Pricing page</Link>.</> },
        { id: 'faq2', question: 'How does it work?', answer: <>Think of us as an image post-processor, we require good quality inputs to create good quality output. You provide us with great photos of your product on a stand-in fit model, we provide you endless iteration. Want to learn more? Check out the <Link to="/how-it-works">How it Works page</Link>.</> },
        { id: 'faq3', question: 'Where are you based out of?', answer: <>We are based out of North Vancouver, BC as a Canadian owned and operated company. Interested in reaching out? <Link to="/contact">Give us a shout</Link></> },
        { id: 'faq4', question: 'How long does it take?', answer: 'The generative process is fairly quick, though we require time to train and match your artistic style and direction, so expect this to take up to 5 business days.' },
        { id: 'faq5', question: 'Are there usage limitations?', answer: 'Unlike modelling agencies we do not limit how or where you use the avatars. Once the assets are generated, they are yours to use freely for commercial use.' },
    ];

    const animateGlyph = (itemId, from, to) => {
        let current = from;
        const step = from < to ? 1 : -1;

        // Clear any existing interval for this itemId to prevent animation conflicts
        // This is important if a glyph animation is interrupted by a new click
        if (glyphs[itemId]?.intervalId) {
            clearInterval(glyphs[itemId].intervalId);
        }

        const intervalId = setInterval(() => {
            const glyph = `g${current.toString().padStart(2, '0')}`;
            setGlyphs(prev => ({ ...prev, [itemId]: { glyph, intervalId } })); // Store intervalId

            if (current === to) {
                clearInterval(intervalId);
                setGlyphs(prev => {
                    const newState = { ...prev };
                    delete newState[itemId].intervalId; // Clean up intervalId
                    return newState;
                });
            } else {
                current += step;
            }
        }, 25); // 25ms per step
    };

    const handleToggle = (itemId) => {
        const isCurrentlyOpen = openItemId === itemId;
        const prevOpenItemId = openItemId; // Store the ID of the previously open item

        // If an item was previously open and it's not the one being clicked now,
        // animate its glyph back to the initial state (g01)
        if (prevOpenItemId && prevOpenItemId !== itemId) {
            animateGlyph(prevOpenItemId, 5, 1); // Animate previously open glyph from g05 to g01
        }

        // Animate the glyph for the clicked item
        animateGlyph(itemId, isCurrentlyOpen ? 5 : 1, isCurrentlyOpen ? 1 : 5);

        // Toggle open/close state for the accordion
        setOpenItemId(isCurrentlyOpen ? null : itemId);
    };

    // Initialize glyphs for all items to 'g01' on mount
    useEffect(() => {
        const initialGlyphs = {};
        faqItems.forEach(item => {
            initialGlyphs[item.id] = { glyph: 'g01' };
        });
        setGlyphs(initialGlyphs);
    }, []);


    return (

<section className="container my-5 py-3">
  <div className="row justify-content-center">
    <div className="col-12 col-lg-8">
                  <h2 className="text-center f-a f-uc mb-4 text-3xl md:text-4xl">
        Frequently Asked
      </h2>

      <div className="accordion" id="faqAccordion">
        {faqItems.map((item) => {
          const isOpen = openItemId === item.id;

          return (
            <div key={item.id}>
              <div
                className="faq-item card-header bg-white rounded-t-lg p-2 cursor-pointer"
                id={`heading${item.id}`}
                onClick={() => handleToggle(item.id)}
                style={{
                  fontWeight: isOpen ? '600' : 'normal',
                  cursor: 'pointer',
                }}
              >
                <p className="mb-0 fs-5 d-flex justify-content-between align-items-center">
                  {item.question}
                  <GlyphSvg
                    glyph={glyphs[item.id]?.glyph || 'g01'}
                    size="12"
                    color="var(--c2)" />
                </p>
              </div>

              <div
                id={item.id}
                className="faq-body"
                data-state={isOpen ? 'open' : 'closed'}
                aria-labelledby={`heading${item.id}`}
                style={{
                  maxHeight: isOpen ? '1000px' : '0px', // fallback
                  opacity: isOpen ? 1 : 0,
                  transition: isOpen
                    ? 'max-height 0.8s ease-out, opacity 0.5s ease-out'
                    : 'max-height 0.3s ease-in, opacity 0.2s ease-in',
                  overflow: 'hidden',
                }}
                ref={(el) => {
                  if (el) {
                    const body = el.querySelector('.card-body');
                    if (body) {
                      const fullHeight = body.scrollHeight;
                      el.style.maxHeight = isOpen ? `${fullHeight}px` : '0px';
                    }
                  }
                }}
              >
                <div className="card-body p-4 text-gray-600 text-base">
                  {item.answer}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  </div>
</section>

    );
}